// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://xqcuseqbfkxtliovdtwv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "sb_publishable_B4dAlNxwp6ugRaBdg5sCKA_x2YCQnfo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
